import { userDomain } from '@user';

export const useGenderMap = () => {
  return {
    [userDomain.Gender.Male]: 'Мужской',
    [userDomain.Gender.Female]: 'Женский',
    [userDomain.Gender.Any]: 'Любой',
  };
};
